import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgIf } from '@angular/common';

import { NumberFormat } from '../../utils/number.format';
import { HiddenNumberPipe } from '../../pipes/hidden-number.pipe';

@Component({
	selector: 'copo-numeric-percentage-cell',
	templateUrl: './numeric-percentage-cell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, HiddenNumberPipe]
})
export class NumericPercentageCellComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;

	value: number | undefined;
	format: NumberFormat | undefined;

	constructor(readonly changeDetectorRef: ChangeDetectorRef) {}

	agInit(params: ICellRendererParams<unknown, number>) {
		this.updateValue(params);
		this.changeDetectorRef.markForCheck();
	}

	refresh(params: ICellRendererParams<unknown, number>) {
		this.updateValue(params);
		this.changeDetectorRef.markForCheck();
		return true;
	}

	private updateValue(params: ICellRendererParams<unknown, number>) {
		const valueType = params.value && typeof params.value === 'string'
			? { format: 'percentage', value: params.value }
			: { format: 'weight-with-zero', value: params.value };
		this.format = <NumberFormat> valueType.format;
		this.value = valueType.value ?? undefined;
	}
}
